import type { $Fetch } from 'nitropack';
import type { BFFResponse } from '~/types/BFFResponse';

export default ($fetch: $Fetch) => {
  const getDeliveryTime = async () => $fetch<BFFResponse<DeliveryTime>>('/deliveryTime');
  return {
    getDeliveryTime,
  };
};
